/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svcat_ExtensionsInputs */

const en_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensions`)
};

const ar_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`إضافات`)
};

const bn_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`এক্সটেনশন`)
};

const de_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Erweiterungen`)
};

const es_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensiones`)
};

const fr_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensions`)
};

const pt_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Extensões`)
};

const zh_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`扩展`)
};

const tr_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Uzantılar`)
};

const ru_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Расширения`)
};

const pl_svcat_extensions = /** @type {(inputs: Svcat_ExtensionsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rozszerzenia`)
};

/**
* | output |
* | --- |
* | "Extensions" |
*
* @param {Svcat_ExtensionsInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svcat_extensions = /** @type {((inputs?: Svcat_ExtensionsInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svcat_ExtensionsInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svcat_extensions(inputs)
	if (locale === "bn") return bn_svcat_extensions(inputs)
	if (locale === "de") return de_svcat_extensions(inputs)
	if (locale === "es") return es_svcat_extensions(inputs)
	if (locale === "fr") return fr_svcat_extensions(inputs)
	if (locale === "pt") return pt_svcat_extensions(inputs)
	if (locale === "zh") return zh_svcat_extensions(inputs)
	if (locale === "tr") return tr_svcat_extensions(inputs)
	if (locale === "ru") return ru_svcat_extensions(inputs)
	if (locale === "pl") return pl_svcat_extensions(inputs)
	return en_svcat_extensions(inputs)
});